var React = require('react');

function BlueArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"aeceedd2-90fd-49f4-8769-a3c9efb603de","data-name":"Calque 2"},React.createElement("g",{"id":"e13e6647-fb79-486a-a798-0002f8dd9fb9","data-name":"Calque 1"},[React.createElement("path",{"d":"M389.49,262.57c-8.62.31-17.27.49-26,.49A711.44,711.44,0,0,1,95,210.69,397.56,397.56,0,0,0,0,285.45a817.35,817.35,0,0,0,348.85,84.69A179.73,179.73,0,0,0,389.49,262.57Z","style":{"fill":"#7db0c8"},"key":0}),React.createElement("path",{"d":"M367.29,293.06A285.54,285.54,0,0,1,274,504.5H415A397.86,397.86,0,0,0,405.09,58H244.51A286,286,0,0,1,367.29,293.06Z","style":{"fill":"#7db0c8"},"key":1}),React.createElement("path",{"d":"M573.38,528.5H690a606.24,606.24,0,0,0,39.48-215.91A604.85,604.85,0,0,0,643,0H512.62a500.94,500.94,0,0,1,60.76,528.5Z","style":{"fill":"#7db0c8"},"key":2})])));
}

BlueArrow.defaultProps = {"viewBox":"0 0 729.47 528.5"};

module.exports = BlueArrow;

BlueArrow.default = BlueArrow;
